import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation,} from '@angular/core';
import {ProleisObject, Task} from 'proleis-rest-client';
import {RedirectService} from '../../services/redirect.service';
import {AppConfigService} from 'proleis-web-app';
import {PpsService} from '../../../planning/components/pps/board/pps.service';
import {ChainInfoComponent} from './chain-info/chain-info.component';
import {TaskComponentConfig, TaskComponentField} from "./task.config";

@Component({
  selector: 'p4m-mobile-task-component',
  templateUrl: 'mobile-task.component.html',
  styleUrls: ['mobile-task.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MobileTaskComponent implements OnInit {
  @ViewChild('predecessors') predecessors: ChainInfoComponent;
  @ViewChild('successors') successors: ChainInfoComponent;

  allowStartTracking = false;
  allowSetUnapprovedTasksInProgress = false;
  @Input() showResource = false;
  @Input() task: Task;
  @Input() user: ProleisObject;
  @Input() taskComponentConfig: TaskComponentConfig;
  @Output() onStartTracking = new EventEmitter<Task>();
  @Output() onStopTracking = new EventEmitter<Task>();
  @Output() onTaskUpdated = new EventEmitter<Task>();

  constructor(
    private redirectService: RedirectService,
    private configService: AppConfigService,
    public ppsService: PpsService,
  ) {
  }

  ngOnInit() {
    const config: any = this.configService.getConfig();
    this.allowStartTracking = config.general.allowStartTracking;
    this.allowSetUnapprovedTasksInProgress =
      config.general.allowSetUnapprovedTasksInProgress;
  }

  getTaskStatusClass(task: Task): string {
    if (task.ISTBEARBEITET) {
      return 'task-finished';
    } else if (task.ISTINARBEIT && !task.ISTBEARBEITET) {
      return 'task-in-progress';
    } else if (task.FREIGABE_STATUS === 0) {
      return 'task-todo-red';
    } else if (task.FREIGABE_STATUS < 100) {
      return 'task-todo-yellow';
    } else {
      return 'task-todo-green';
    }
  }

  hideField(task: Task, field: TaskComponentField) {
    if (!field.hideIf) return false;

    return task['HIDEIF_' + field.field]
  }

  getProgress() {
    return (this.task.ARBEITIST / this.task.ARBEITPLAN) * 100;
  }

  onRedirect(task: Task) {
    this.redirectService.redirectToInfoPanel(task.OBJECT_ID);
  }

  redirect(id: string) {
    this.redirectService.redirectToInfoPanel(id);
  }

  startTracking(task: Task) {
    //this.onStartTracking.emit(task);
  }

  stopTracking(task: Task) {
    this.onStopTracking.emit(task);
  }

  hasActiveTracking(task: Task, user: ProleisObject) {
    return task?.ACTIVE_BOOKING_CURRENT_USER_ID === user?.OBJECT_ID;
  }

  onCardExpanded(expanded: boolean) {
    if (expanded) {
      this.predecessors?.fetchLink();
      this.successors?.fetchLink();
    }
  }
}
